<div class="rooms">
  <div *ngFor="let room of rooms; let i = index" [ngStyle]="{
            'background-color': getRoomColor(room.id),
            'padding': '10px',
            'color': getRoomTextColor(room.id),
            'margin-bottom': '12px'
  }">
    {{room.name}}
  </div>
</div>
<div class="schedule-container" *ngIf="startDate && endDate && lessonsSchedule.length">
  <table class="schedule-table">
    <thead>
    <tr>
      <th class="time sticky-col">Time</th>
      <th *ngFor="let d of days; let idx = index" [class.week-separator]="isStartOfWeek(d.date) && idx !== 0">
        {{ formatDate(d.date) }}
      </th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let slot of slots">
      <ng-container *ngFor="let room of slot.rooms; let i = index">
        <tr>
          <td *ngIf="i === 0" [attr.rowspan]="slot.rooms.length" class="time sticky-col ">
            {{ slot.time }}
          </td>
          <td *ngFor="let d of days; let idx = index" [ngStyle]="{
                  'background-color': getRoomColor(room.id),
                  color: getRoomTextColor(room.id),
                }" [class.week-separator]="isStartOfWeek(d.date) && idx !== 0">
            <ng-container *ngFor="let event of room.eventsByDay[d.day] || []">
              <div *ngIf="isDateInRange(event, d.date, slot.time)"
                   class="event-box editable-lesson"
                   [ngStyle]="{
                    'background-color': getRoomColor(room.id),
                    color: getRoomTextColor(room.id)
                   }"
                   (click)="editLessonClick(event)">
                <ng-container *ngIf="getTeacherName(event.teacherId)">
                <strong>{{ getTeacherName(event.teacherId)}}</strong><br>
                </ng-container>
                {{ event.name }}
              </div>
            </ng-container>
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </table>

</div>
